import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xdmpreWxoMCB7CiAgZGlzcGxheTogaW5saW5lLWZsZXg7CiAgZmxleDogbm9uZTsKfQ';
export var lottieWrapper = '_1vjkylh0';